import React, { useMemo } from 'react';
import { useCallback } from 'react';
import request from '../../../../../../helpers/request';
import { useMutation, useQueryClient } from 'react-query';
import { getDataAfterSubmit } from '../utils/getDataAfterSubmit';
import { message } from 'antd';
import { useRouteMatch } from 'react-router-dom';
import { getQueryKeys } from '../../../../queries/queryKeys';

const getId = (value) => {
  const id = Number(value);

  return !isNaN(id) ? id : undefined;
};

const useSubmit = ({ url, errMsg }) => {
  const queryClient = useQueryClient();
  const { params } = useRouteMatch();

  const houseId = useMemo(() => getId(params.pageId), [params.pageId]);

  const change = useCallback(
    ({ body }) => request.put(url, body, errMsg, 'Error'),
    [url, errMsg]
  );

  const changeMutation = useMutation(change, {
    onSuccess: async (res, { flats, massActionsTextError }) => {
      if (res !== 'Error') {
        const data = getDataAfterSubmit({ items: res, flats });

        const { failedFlats } = data;

        if (failedFlats.length > 0) {
          message.error(
            <div>
              <div style={{ backgroundColor: 'green' }}>
                У данных квартир произошла ошибка при изменении
                {massActionsTextError}:
              </div>
              <div style={{ marginTop: 8 }}>
                {failedFlats?.map((flat) => (
                  <div key={flat.addressId}>
                    {flat.address?.synonym || flat.address?.name}
                  </div>
                ))}
              </div>
            </div>
          );
        }

        queryClient.invalidateQueries(getQueryKeys.flatsGrid(houseId));
      }
    },
  });

  return {
    submitAsync: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};

export default useSubmit;
